import React, { memo, useContext } from 'react';

import { PrintCancelDialog } from 'components/Print';
import { AccessOfflineContentDialog } from 'components/Offline';
import { PDFExperienceDialog, InactivityDialog } from 'components';
import { TTSDialog } from 'components/TTS';
import {
  PrintValuesContext,
  PrintModifiersContext,
  OfflineValuesContext,
  OfflineModifiersContext,
} from 'contexts';

import { usePDFWarning } from './hooks/usePDFWarning';
import { useInactivity } from './hooks/useInactivity';
import { useTTSDialog } from './hooks/useTTSDialog';

const DialogOverlay = ({ ...props }) => {
  const { isCancelPrintDialogOpen } = useContext(PrintValuesContext);
  const {
    cancelPrintJob,
    setIsCancelPrintDialogOpen,
    setIsCurrentPrintJobCanceled,
  } = useContext(PrintModifiersContext);

  const { isAccessOfflineContentDialogOpen } = useContext(OfflineValuesContext);
  const { closeAccessOfflineContentDialog } = useContext(
    OfflineModifiersContext,
  );

  const { shouldOpenPDFWarningDialog, setShouldOpenPDFWarningDialog } =
    usePDFWarning();

  const { openInactivityDialog, inactivityDialogAction } = useInactivity();

  const {
    isTTSDialogOpen,
    handleTTSDialogClose,
    handleTTSDialogLeaveAsIs,
    handleTTSDialogFitToScreen,
  } = useTTSDialog();

  return (
    <div {...props}>
      <PrintCancelDialog
        isOpen={isCancelPrintDialogOpen}
        closeAction={() => {
          setIsCurrentPrintJobCanceled(false);
          setIsCancelPrintDialogOpen(false);
        }}
        confirmAction={() => {
          cancelPrintJob();
          setIsCurrentPrintJobCanceled(true);
          setIsCancelPrintDialogOpen(false);
        }}
      />
      <AccessOfflineContentDialog
        isOpen={isAccessOfflineContentDialogOpen}
        closeAction={() => {
          closeAccessOfflineContentDialog();
        }}
        confirmAction={(dontShowAgain) => {
          closeAccessOfflineContentDialog(dontShowAgain);
        }}
      />
      <PDFExperienceDialog
        isOpen={shouldOpenPDFWarningDialog}
        setIsOpen={setShouldOpenPDFWarningDialog}
      />
      <InactivityDialog
        open={openInactivityDialog}
        dialogAction={inactivityDialogAction}
      />
      <TTSDialog
        open={isTTSDialogOpen}
        handleClose={handleTTSDialogClose}
        handleLeaveAsIs={handleTTSDialogLeaveAsIs}
        handleFitToScreen={handleTTSDialogFitToScreen}
      />
    </div>
  );
};

export default memo(DialogOverlay);
